{
  "address": "7xeok2vd2ouBAGUG7N6hb1bSUpB6AeonELzjBS772kCR",
  "metadata": {
    "name": "soloto",
    "version": "0.1.0",
    "spec": "0.1.0"
  },
  "instructions": [
    {
      "name": "buy_tickets",
      "discriminator": [
        48,
        16,
        122,
        137,
        24,
        214,
        198,
        58
      ],
      "accounts": [
        {
          "name": "lottery",
          "writable": true
        },
        {
          "name": "player_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  108,
                  97,
                  121,
                  101,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "lottery"
              },
              {
                "kind": "account",
                "path": "buyer"
              }
            ]
          }
        },
        {
          "name": "vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118,
                  97,
                  117,
                  108,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "lottery"
              }
            ]
          }
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "buyer",
          "writable": true,
          "signer": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "pyth_sol_usd"
        }
      ],
      "args": [
        {
          "name": "quantity",
          "type": "u64"
        }
      ]
    },
    {
      "name": "commit_draw",
      "discriminator": [
        210,
        106,
        32,
        68,
        253,
        95,
        229,
        1
      ],
      "accounts": [
        {
          "name": "lottery",
          "writable": true
        },
        {
          "name": "randomness_account"
        },
        {
          "name": "vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118,
                  97,
                  117,
                  108,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "lottery"
              }
            ]
          }
        },
        {
          "name": "reserve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  114,
                  101,
                  115,
                  101,
                  114,
                  118,
                  101
                ]
              }
            ]
          }
        },
        {
          "name": "committer",
          "signer": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "initialize_config",
      "discriminator": [
        208,
        127,
        21,
        1,
        194,
        190,
        196,
        70
      ],
      "accounts": [
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true
        },
        {
          "name": "program_data",
          "docs": [
            "CHECK (N1) : ProgramData du programme, validé dans le handler (PDA canonique +",
            "upgrade_authority == authority). Sert à n'autoriser l'init que par le déployeur."
          ]
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "initialize_lottery",
      "discriminator": [
        113,
        199,
        243,
        247,
        73,
        217,
        33,
        11
      ],
      "accounts": [
        {
          "name": "lottery",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  108,
                  111,
                  116,
                  116,
                  101,
                  114,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "config.total_draws",
                "account": "GlobalConfig"
              }
            ]
          }
        },
        {
          "name": "vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118,
                  97,
                  117,
                  108,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "lottery"
              }
            ]
          }
        },
        {
          "name": "reserve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  114,
                  101,
                  115,
                  101,
                  114,
                  118,
                  101
                ]
              }
            ]
          }
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "prev_lottery"
        },
        {
          "name": "platform_wallet"
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": [
            "config"
          ]
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "price_usd_cents",
          "type": "u64"
        },
        {
          "name": "max_tickets",
          "type": "u64"
        },
        {
          "name": "draw_timestamp",
          "type": "i64"
        },
        {
          "name": "seed_jackpot",
          "type": "u64"
        },
        {
          "name": "draw_authority",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "open_next_lottery",
      "discriminator": [
        32,
        59,
        203,
        117,
        61,
        53,
        85,
        234
      ],
      "accounts": [
        {
          "name": "lottery",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  108,
                  111,
                  116,
                  116,
                  101,
                  114,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "config.total_draws",
                "account": "GlobalConfig"
              }
            ]
          }
        },
        {
          "name": "vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118,
                  97,
                  117,
                  108,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "lottery"
              }
            ]
          }
        },
        {
          "name": "reserve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  114,
                  101,
                  115,
                  101,
                  114,
                  118,
                  101
                ]
              }
            ]
          }
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "prev_lottery"
        },
        {
          "name": "opener",
          "writable": true,
          "signer": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "draw_timestamp",
          "type": "i64"
        }
      ]
    },
    {
      "name": "reset_commit",
      "discriminator": [
        104,
        10,
        157,
        86,
        195,
        226,
        114,
        110
      ],
      "accounts": [
        {
          "name": "lottery",
          "writable": true
        },
        {
          "name": "caller",
          "signer": true
        }
      ],
      "args": []
    },
    {
      "name": "reveal_draw",
      "discriminator": [
        13,
        149,
        75,
        226,
        184,
        105,
        114,
        48
      ],
      "accounts": [
        {
          "name": "lottery",
          "writable": true
        },
        {
          "name": "randomness_account"
        },
        {
          "name": "winner_player_account",
          "docs": [
            "- Cas solo rollover : non utilisé (gagnant identifié via lottery.rollover_player).",
            "- Cas failed rollover : PlayerAccount de l'ANCIENNE loterie échouée.",
            "- Cas normal : PlayerAccount de la loterie courante."
          ]
        },
        {
          "name": "vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118,
                  97,
                  117,
                  108,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "lottery"
              }
            ]
          }
        },
        {
          "name": "reserve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  114,
                  101,
                  115,
                  101,
                  114,
                  118,
                  101
                ]
              }
            ]
          }
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "winner",
          "writable": true
        },
        {
          "name": "platform",
          "writable": true
        },
        {
          "name": "revealer",
          "signer": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "rollover_failed_draw",
      "discriminator": [
        2,
        32,
        55,
        68,
        47,
        84,
        128,
        87
      ],
      "accounts": [
        {
          "name": "lottery",
          "writable": true
        },
        {
          "name": "vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118,
                  97,
                  117,
                  108,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "lottery"
              }
            ]
          }
        },
        {
          "name": "reserve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  114,
                  101,
                  115,
                  101,
                  114,
                  118,
                  101
                ]
              }
            ]
          }
        },
        {
          "name": "caller",
          "signer": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "set_recurring_params",
      "discriminator": [
        146,
        100,
        96,
        99,
        198,
        156,
        144,
        255
      ],
      "accounts": [
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "platform_wallet"
        },
        {
          "name": "authority",
          "signer": true,
          "relations": [
            "config"
          ]
        }
      ],
      "args": [
        {
          "name": "draw_authority",
          "type": "pubkey"
        },
        {
          "name": "price_usd_cents",
          "type": "u64"
        },
        {
          "name": "max_tickets",
          "type": "u64"
        }
      ]
    }
  ],
  "accounts": [
    {
      "name": "GlobalConfig",
      "discriminator": [
        149,
        8,
        156,
        202,
        160,
        252,
        176,
        217
      ]
    },
    {
      "name": "Lottery",
      "discriminator": [
        162,
        182,
        26,
        12,
        164,
        214,
        112,
        3
      ]
    },
    {
      "name": "PlayerAccount",
      "discriminator": [
        224,
        184,
        224,
        50,
        98,
        72,
        48,
        236
      ]
    }
  ],
  "events": [
    {
      "name": "DrawCommitted",
      "discriminator": [
        228,
        156,
        123,
        212,
        154,
        211,
        83,
        218
      ]
    },
    {
      "name": "DrawExecuted",
      "discriminator": [
        96,
        224,
        0,
        159,
        147,
        51,
        194,
        100
      ]
    },
    {
      "name": "DrawFailedRollover",
      "discriminator": [
        13,
        214,
        90,
        59,
        140,
        6,
        26,
        164
      ]
    },
    {
      "name": "DrawRollover",
      "discriminator": [
        15,
        181,
        72,
        110,
        123,
        140,
        60,
        210
      ]
    },
    {
      "name": "LotteryInitialized",
      "discriminator": [
        198,
        188,
        153,
        94,
        232,
        47,
        124,
        219
      ]
    },
    {
      "name": "PrizeAutoSent",
      "discriminator": [
        143,
        95,
        8,
        93,
        139,
        93,
        97,
        28
      ]
    },
    {
      "name": "TicketsPurchased",
      "discriminator": [
        185,
        114,
        111,
        225,
        124,
        92,
        18,
        143
      ]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "LotteryClosed",
      "msg": "La loterie est fermée"
    },
    {
      "code": 6001,
      "name": "InvalidTimestamp",
      "msg": "Timestamp de tirage invalide"
    },
    {
      "code": 6002,
      "name": "InvalidTicketPrice",
      "msg": "Prix du ticket invalide"
    },
    {
      "code": 6003,
      "name": "InvalidMaxTickets",
      "msg": "Nombre max de tickets invalide (1-8)"
    },
    {
      "code": 6004,
      "name": "InvalidQuantity",
      "msg": "Quantité invalide (1 à 8)"
    },
    {
      "code": 6005,
      "name": "MaxTicketsReached",
      "msg": "Maximum 8 tickets par wallet atteint"
    },
    {
      "code": 6006,
      "name": "InsufficientFunds",
      "msg": "Fonds insuffisants"
    },
    {
      "code": 6007,
      "name": "Overflow",
      "msg": "Overflow arithmétique"
    },
    {
      "code": 6008,
      "name": "DrawNotReady",
      "msg": "Le tirage n'est pas encore prêt"
    },
    {
      "code": 6009,
      "name": "VrfReadError",
      "msg": "Erreur de lecture du compte Randomness"
    },
    {
      "code": 6010,
      "name": "NoTickets",
      "msg": "Aucun ticket vendu"
    },
    {
      "code": 6011,
      "name": "Unauthorized",
      "msg": "Non autorisé"
    },
    {
      "code": 6012,
      "name": "DrawAlreadyExecuted",
      "msg": "Le tirage a déjà été exécuté"
    },
    {
      "code": 6013,
      "name": "DrawAlreadyCommitted",
      "msg": "Le tirage a déjà été engagé (commit)"
    },
    {
      "code": 6014,
      "name": "DrawNotCommitted",
      "msg": "Le tirage n'a pas encore été engagé (commit)"
    },
    {
      "code": 6015,
      "name": "DrawTimePassed",
      "msg": "Le délai du tirage est passé"
    },
    {
      "code": 6016,
      "name": "WrongWinnerAccount",
      "msg": "Le compte joueur ne correspond pas au gagnant"
    },
    {
      "code": 6017,
      "name": "VaultRentViolation",
      "msg": "Le retrait violerait la rent-exemption du vault"
    },
    {
      "code": 6018,
      "name": "WrongPlatformWallet",
      "msg": "Le wallet plateforme fourni est incorrect"
    },
    {
      "code": 6019,
      "name": "RandomnessExpired",
      "msg": "L'aléatoire a expiré (fenêtre de slots dépassée)"
    },
    {
      "code": 6020,
      "name": "RandomnessAlreadyRevealed",
      "msg": "L'aléatoire a déjà été révélé"
    },
    {
      "code": 6021,
      "name": "RandomnessNotResolved",
      "msg": "L'aléatoire n'est pas encore résolu"
    },
    {
      "code": 6022,
      "name": "InvalidRandomnessAccount",
      "msg": "Compte Randomness invalide (ne correspond pas au commit)"
    },
    {
      "code": 6023,
      "name": "CommitNotExpired",
      "msg": "Le commit n'a pas encore expiré : l'aléa reste révélable (~512 slots / ~3 min 30 après le commit_slot)"
    },
    {
      "code": 6024,
      "name": "RolloverNotAvailable",
      "msg": "Report non disponible : délai de 48h non écoulé"
    },
    {
      "code": 6025,
      "name": "PythPriceInvalid",
      "msg": "Prix Pyth invalide ou négatif"
    },
    {
      "code": 6026,
      "name": "PythPriceStale",
      "msg": "Prix Pyth trop ancien (> 60s)"
    },
    {
      "code": 6027,
      "name": "WrongPythAccount",
      "msg": "Compte Pyth SOL/USD incorrect"
    },
    {
      "code": 6028,
      "name": "ParamsNotSet",
      "msg": "Réglages récurrents non posés — appelle set_recurring_params d'abord"
    },
    {
      "code": 6029,
      "name": "InsufficientReserve",
      "msg": "Réserve insuffisante pour couvrir le rent de la nouvelle loterie"
    },
    {
      "code": 6030,
      "name": "BrokenRolloverChain",
      "msg": "Chaîne de reports invalide ou incomplète (remaining_accounts)"
    },
    {
      "code": 6031,
      "name": "InvalidPreviousLottery",
      "msg": "Loterie précédente invalide (illisible ou pas la précédente immédiate)"
    },
    {
      "code": 6032,
      "name": "PreviousDrawNotExecuted",
      "msg": "Loterie précédente non clôturée — impossible d'ouvrir la suivante"
    },
    {
      "code": 6033,
      "name": "NotCurrentLottery",
      "msg": "Cette loterie n'est pas la loterie en cours"
    }
  ],
  "types": [
    {
      "name": "DrawCommitted",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "lottery",
            "type": "pubkey"
          },
          {
            "name": "draw_number",
            "type": "u64"
          },
          {
            "name": "commit_slot",
            "type": "u64"
          },
          {
            "name": "timestamp",
            "type": "i64"
          }
        ]
      }
    },
    {
      "name": "DrawExecuted",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "lottery",
            "type": "pubkey"
          },
          {
            "name": "draw_number",
            "type": "u64"
          },
          {
            "name": "winning_ticket",
            "type": "u64"
          },
          {
            "name": "total_tickets",
            "type": "u64"
          },
          {
            "name": "jackpot",
            "type": "u64"
          },
          {
            "name": "timestamp",
            "type": "i64"
          }
        ]
      }
    },
    {
      "name": "DrawFailedRollover",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "lottery",
            "type": "pubkey"
          },
          {
            "name": "draw_number",
            "type": "u64"
          },
          {
            "name": "jackpot",
            "type": "u64"
          },
          {
            "name": "participant_count",
            "type": "u64"
          },
          {
            "name": "total_tickets",
            "type": "u64"
          },
          {
            "name": "timestamp",
            "type": "i64"
          }
        ]
      }
    },
    {
      "name": "DrawRollover",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "lottery",
            "type": "pubkey"
          },
          {
            "name": "draw_number",
            "type": "u64"
          },
          {
            "name": "jackpot",
            "type": "u64"
          },
          {
            "name": "solo_winner",
            "type": "pubkey"
          },
          {
            "name": "rollover_tickets",
            "type": "u64"
          },
          {
            "name": "timestamp",
            "type": "i64"
          }
        ]
      }
    },
    {
      "name": "GlobalConfig",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "authority",
            "type": "pubkey"
          },
          {
            "name": "total_draws",
            "type": "u64"
          },
          {
            "name": "total_prizes_paid",
            "type": "u64"
          },
          {
            "name": "last_winner",
            "type": "pubkey"
          },
          {
            "name": "current_lottery_key",
            "type": "pubkey"
          },
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "params_set",
            "type": "bool"
          },
          {
            "name": "draw_authority",
            "type": "pubkey"
          },
          {
            "name": "platform_wallet",
            "type": "pubkey"
          },
          {
            "name": "price_usd_cents",
            "type": "u64"
          },
          {
            "name": "max_tickets",
            "type": "u64"
          },
          {
            "name": "_reserved",
            "type": {
              "array": [
                "u8",
                128
              ]
            }
          }
        ]
      }
    },
    {
      "name": "Lottery",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "authority",
            "type": "pubkey"
          },
          {
            "name": "draw_authority",
            "type": "pubkey"
          },
          {
            "name": "platform_wallet",
            "type": "pubkey"
          },
          {
            "name": "price_usd_cents",
            "type": "u64"
          },
          {
            "name": "max_tickets",
            "type": "u64"
          },
          {
            "name": "draw_timestamp",
            "type": "i64"
          },
          {
            "name": "total_tickets",
            "type": "u64"
          },
          {
            "name": "participant_count",
            "type": "u64"
          },
          {
            "name": "jackpot",
            "type": "u64"
          },
          {
            "name": "next_seed",
            "type": "u64"
          },
          {
            "name": "is_open",
            "type": "bool"
          },
          {
            "name": "draw_committed",
            "type": "bool"
          },
          {
            "name": "draw_executed",
            "type": "bool"
          },
          {
            "name": "prize_claimed",
            "type": "bool"
          },
          {
            "name": "rollover",
            "type": "bool"
          },
          {
            "name": "failed_draw",
            "type": "bool"
          },
          {
            "name": "winner",
            "type": "pubkey"
          },
          {
            "name": "first_player",
            "type": "pubkey"
          },
          {
            "name": "randomness_account",
            "type": "pubkey"
          },
          {
            "name": "commit_slot",
            "type": "u64"
          },
          {
            "name": "winning_ticket",
            "type": "u64"
          },
          {
            "name": "draw_number",
            "type": "u64"
          },
          {
            "name": "vault_bump",
            "type": "u8"
          },
          {
            "name": "rollover_player",
            "type": "pubkey"
          },
          {
            "name": "rollover_ticket_end",
            "type": "u64"
          },
          {
            "name": "failed_lottery",
            "type": "pubkey"
          },
          {
            "name": "rollover_ticket_count",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "LotteryInitialized",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "lottery",
            "type": "pubkey"
          },
          {
            "name": "draw_number",
            "type": "u64"
          },
          {
            "name": "price_usd_cents",
            "type": "u64"
          },
          {
            "name": "draw_timestamp",
            "type": "i64"
          },
          {
            "name": "seed_jackpot",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "PlayerAccount",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "wallet",
            "type": "pubkey"
          },
          {
            "name": "lottery",
            "type": "pubkey"
          },
          {
            "name": "tickets_owned",
            "type": "u64"
          },
          {
            "name": "ticket_numbers",
            "type": {
              "array": [
                "u64",
                8
              ]
            }
          },
          {
            "name": "total_paid_lamports",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "PrizeAutoSent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "winner",
            "type": "pubkey"
          },
          {
            "name": "prize_amount",
            "type": "u64"
          },
          {
            "name": "platform_fee",
            "type": "u64"
          },
          {
            "name": "next_seed",
            "type": "u64"
          },
          {
            "name": "draw_number",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "TicketsPurchased",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "buyer",
            "type": "pubkey"
          },
          {
            "name": "quantity",
            "type": "u64"
          },
          {
            "name": "total_cost",
            "type": "u64"
          },
          {
            "name": "ticket_start",
            "type": "u64"
          },
          {
            "name": "jackpot",
            "type": "u64"
          },
          {
            "name": "total_tickets",
            "type": "u64"
          }
        ]
      }
    }
  ]
}